export default __webpack_public_path__ + "static/media/exemplo_whatsapp.9d15c7b7.csv";